"use strict";

const $ = jQuery;
// const Swiper = Swiper;

module.exports = class {
	#$module;
    #$swiper;
    #$slides;
    #$pagination;
    #$prevButton;
    #$nextButton;
    #$paginationDots;

    #swiperConfig;
    #swiper;
	#data;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;

        this.#$swiper = this.#$module.find('.swiper-container');
        this.#$slides = this.#$swiper.find('.swiper-slide');
        this.#$pagination = this.#$module.find('.swiper-pagination');
        this.#$prevButton = this.#$module.find('.swiper-button-prev');
        this.#$nextButton = this.#$module.find('.swiper-button-next');
        this.#$paginationDots = this.$module.find('.swiper-pagination-bullet');

        this.#swiperConfig = {
            loop: true,
            autoplay: {
                delay: 10000,
            },
            slidesPerView: 1,
            autoHeight: false,
            spaceBetween: 0,
            speed: 1000,
            pagination: {
                el: `.fl-node-${this.#$module.attr('data-node')} .swiper-pagination`,
                clickable: true,
            },
            effect: 'fade',
            crossFade: false,
            navigation: {
                nextEl: `.fl-node-${this.#$module.attr('data-node')} .swiper-button-next`,
                prevEl: `.fl-node-${this.#$module.attr('data-node')} .swiper-button-prev`,
                preloadImages: false,
                updateOnImagesReady: false
            },
            on: {
                beforeInit: (swiper) => {
                    this.#$module.trigger('bb-lumeris:lum-broker-slider:beforeInit', { module: this });
                },
                init: (swiper) => {
                    this.#$module.trigger('bb-lumeris:lum-broker-slider:init', { module: this });
                },
                afterInit: (swiper) => {
                    this.#$module.trigger('bb-lumeris:lum-broker-slider:afterInit', { module: this });
                },
                resize: (swiper) => {
                    this.#$module.trigger('bb-lumeris:lum-broker-slider:resize', { module: this });
                }
            }
        };

        this.#swiper = this.initSwiper();
        this.updateLayout();
		this.bind();
	}

	bind() {
		$(window).on('resize', (event) => { return this.onWindowResize(event); });
	}

    get $module() {
        return this.#$module;
    }

    get $slides() {
        return this.#$slides;
    }

    get $pagination() {
        return this.#$pagination;
    }

    get $prevButton() {
        return this.#$prevButton;
    }

    get $nextButton() {
        return this.#$nextButton;
    }

    get $paginationDots() {
        return this.#$paginationDots;
    }

    get swiperConfig() {
        return this.#swiperConfig;
    }

    get swiper() {
        return this.#swiper;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.node;
    }

    set swiperConfig(value) {
        this.#swiperConfig = value;
    }

    set swiper(value) {
        this.#swiper = value;
    }

    initSwiper() {
        return new Swiper(`.fl-node-${this.#$module.attr('data-node')} .swiper-container`, this.swiperConfig);
    }

    updateLayout() {
        if (this.$slides.eq(0).width() <= 575) {
            this.$module.addClass('is-vertical-layout').removeClass('is-horizontal-layout');
        } else {
            this.$module.addClass('is-horizontal-layout').removeClass('is-vertical-layout');
        }

        this.$module.trigger('bb-lumeris:lum-broker-slider:updateLayout', { module: this });
    }

    onWindowResize(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }

        this.updateLayout();
    }
}